<template>
    <div id="app">
        <div class="homepage-div">
            <router-link to="/">
                <img src="./assets/logo.svg" class="google-doc-top-bar" /> <span class="logo-text"><b>
                    <span style="color: #4d8df5;">Doc</span><span style="color: #000000;">Pusher</span>
                </b></span>
            </router-link>
            <div class="avatar" v-if="user && user.profile_picture_uri">
                <b-avatar variant="info" style="margin-right: 10px" v-bind:src="user.profile_picture_uri" badge="FREE" badge-offset="-10px" badge-left v-if="user && user.type !== 'UNLIMITED'"></b-avatar>
                <b-avatar variant="info" style="margin-right: 10px" v-bind:src="user.profile_picture_uri" badge="PREMIUM" badge-offset="-10px" badge-left v-if="user && user.type === 'UNLIMITED'"></b-avatar>
                <b-button size="sm" pill variant="secondary" v-b-tooltip.hover title="Log out" v-on:click="logout">
                    <i class="fas fa-sign-out-alt"></i>
                </b-button>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
import api from './libs/api.js';

export default {
    name: 'App',
    data() {
        return {
            profile_image: false,
            user: {},
        }
    },
    mounted: async function() {
        document.addEventListener(
            "refreshProfile",
            (async () => {
                if(localStorage.getItem('profile')) {
                    const user_profile_data = await api.get_user_info();
                    this.user = user_profile_data;
                }
            }),
            false
        );

        // Emit an event to refresh profile data
        const refresh_profile_event = document.createEvent("Event");
        refresh_profile_event.initEvent("refreshProfile",true,true);
        document.addEventListener("refreshProfile",refresh_profile_event,false);
        document.dispatchEvent(refresh_profile_event);
    },
    methods: {
        logout: function() {
          this.user = {};
          localStorage.clear();
          location.reload();
        }
    }
}
</script>
<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

.avatar {
    float: right;
}

.homepage-div {
    margin: auto;
    padding: 10px;
    max-width: 1000px;
    text-align: left;
}

.google-doc-top-bar {
    max-height: 80px;
    padding-left: 10px;
    padding-bottom: 20px;
}

.filler-text {
    color: #c9c9c9;
}

.logo-text {
    margin-left: 5px;
    font-size: 36px;
}

a:hover, a:visited, a:link, a:active {
    text-decoration: none !important;
}

.btn-primary {
    color: #fff;
    background-color: #4d8df5 !important;
    border-color: #007bff !important;
}
</style>